/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetLanguages200,
  InternalServerErrorResponse
} from '.././model'
import { customInstance } from '../../custom-instance';


// eslint-disable-next-line
  type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;


/**
 * Returns the static language information as defined in the x-language-info component, providing language codes with their English and native labels.
 * @summary Get all available language options
 */
export const getLanguages = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetLanguages200>(
      {url: `https://api.app.usesky.ai/organizations/languages`, method: 'get', signal
    },
      options);
    }
  

export const getGetLanguagesQueryKey = () => {
    
    return [`https://api.app.usesky.ai/organizations/languages`] as const;
    }

    
export const getGetLanguagesQueryOptions = <TData = Awaited<ReturnType<typeof getLanguages>>, TError = InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLanguagesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLanguages>>> = ({ signal }) => getLanguages(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLanguagesQueryResult = NonNullable<Awaited<ReturnType<typeof getLanguages>>>
export type GetLanguagesQueryError = InternalServerErrorResponse

/**
 * @summary Get all available language options
 */
export const useGetLanguages = <TData = Awaited<ReturnType<typeof getLanguages>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetLanguagesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

